import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from "react";
const SvgArrowRightWhite = (props, ref) => (_jsx("svg", { width: 17, height: 16, viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: _jsx("path", { d: "M3.83398 8.00016H13.1673M13.1673 8.00016L8.50065 3.3335M13.1673 8.00016L8.50065 12.6668", stroke: "white", strokeWidth: 1.33333, strokeLinecap: "round", strokeLinejoin: "round" }) }));
const ForwardRef = forwardRef(SvgArrowRightWhite);
export default ForwardRef;
